import { render, staticRenderFns } from "./SquadsPage.vue?vue&type=template&id=1014acfa&"
import script from "./SquadsPage.vue?vue&type=script&lang=js&"
export * from "./SquadsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports